export interface ReplayConfig {
  enabled: boolean;
  baseSamplePct: number;
  checkoutSamplePct: number;
}

const DEFAULT_BASE_SAMPLE_PCT = 5;
const DEFAULT_CHECKOUT_SAMPLE_PCT = 100;

function parsePercent(value: unknown, fallback: number): number {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 100) {
    return fallback;
  }

  return parsed;
}

/**
 * Reads the Mixpanel session-replay configuration from env vars.
 * All knobs are env-driven so replay can be killed or re-tuned without a code change.
 */
export function getReplayConfig(): ReplayConfig {
  return {
    enabled: import.meta.env.VITE_MP_REPLAY_ENABLED === 'true',
    baseSamplePct: parsePercent(import.meta.env.VITE_MP_REPLAY_SAMPLE_PCT, DEFAULT_BASE_SAMPLE_PCT),
    checkoutSamplePct: parsePercent(import.meta.env.VITE_MP_REPLAY_CHECKOUT_SAMPLE_PCT, DEFAULT_CHECKOUT_SAMPLE_PCT),
  };
}

/**
 * Probabilistic gate for a given sampling percentage.
 * 100 always records, 0 never records, otherwise rolls against `Math.random`.
 */
export function shouldRecordPercent(pct: number): boolean {
  if (pct >= 100) {
    return true;
  }

  if (pct <= 0) {
    return false;
  }

  return Math.random() * 100 < pct;
}
